module.exports = __webpack_public_path__ + "img/1alB-a'-cha'.b329bd23.jpg";